export default __webpack_public_path__ + "static/media/element_87.bfe5009d.jpg";